/** @format */

import React, { useState, useRef } from "react";
import style from "./index.module.scss";
import cn from "classnames";
import UploadCloudIcon from "../../../../shared/icons/UploadCloudIcon";
import Loading from "../../../../shared/Loading/Loading";
import DeleteNewIcon from "../../../../shared/icons/DeleteNewIcon";
import EditIconNew from "../../../../shared/icons/EditIconNew";
import DocumentNewIcon from "../../../../shared/icons/DocumentNewIcon";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const MAX_FILE_SIZE = 100 * 1024 * 1024;

const OrderDocumentUpload = ({
  type,
  title,
  file,
  onUploadFile,
  onDeleteFile,
  isRequired = true,
  errorMessage: externalErrorMessage = "",
}) => {
  const { t } = useTranslation();
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [isLoadingUpload, setIsLoadingUpload] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const [internalErrorMessage, setInternalErrorMessage] = useState("");
  const fileInputRef = useRef(null);
  const editFileInputRef = useRef(null);

  // Объединяем внутренние и внешние ошибки
  const errorMessage = externalErrorMessage || internalErrorMessage;

  const validateFileSize = (file) => {
    if (file.size > MAX_FILE_SIZE) {
      setInternalErrorMessage(`Файл ${file.name} превышает максимальный размер 100МБ`);
      toast.error("Файл превышает максимальный размер 100МБ");
      return false;
    }
    return true;
  };

  const handleFileChange = (event) => {
    setInternalErrorMessage("");
    const newFile = event.target.files[0];

    if (newFile && validateFileSize(newFile)) {
      onUploadFile(newFile, type);
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragOver(false);
    setInternalErrorMessage("");

    const newFile = event.dataTransfer.files[0];

    if (newFile && validateFileSize(newFile)) {
      onUploadFile(newFile, type);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = () => {
    setDragOver(false);
  };

  const handleDeleteDocument = () => {
    setIsLoadingDelete(true);
    onDeleteFile(type);
    setIsLoadingDelete(false);
  };

  const handleReplaceFile = () => {
    if (editFileInputRef.current) {
      editFileInputRef.current.click();
    }
  };

  const handleFileReplace = (event) => {
    setInternalErrorMessage("");
    const newFile = event.target.files[0];

    if (!newFile) {
      return;
    }

    if (!validateFileSize(newFile)) {
      if (editFileInputRef.current) {
        editFileInputRef.current.value = "";
      }
      return;
    }

    onUploadFile(newFile, type);

    if (editFileInputRef.current) {
      editFileInputRef.current.value = "";
    }
  };

  return (
    <>
      {!file && (
        <div>
          <div
            className={cn(style.drop_box, {
              [style.drag_over]: dragOver,
              [style.error]: !!errorMessage,
            })}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <div className={style.drop_icon}>
              <UploadCloudIcon style={{ color: "#FA1861" }} />
            </div>
            <div className={style.drop_content}>
              <span className={style.drop_title}>
                {title} {isRequired && <span className={style.required}>*</span>}
              </span>
              <div className={cn(style.drop_textUpload)}>
                <label className={style.drop_uploadFile}>
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                  <span>{t("orderInfo.orderDecisionAviation.dragDocsTitlePart1")}</span>
                </label>
                <span className={style.drop_boxText}>
                  {t("orderInfo.orderDecisionAviation.dragDocsTitlePart2")}
                </span>
              </div>
            </div>
          </div>
          {errorMessage && <p className={style.errorMessage}>{errorMessage}</p>}
        </div>
      )}

      <input
        type="file"
        ref={editFileInputRef}
        onChange={handleFileReplace}
        style={{ display: "none" }}
      />

      {file && (
        <div className={style.fails}>
          <div className={style.fileItem}>
            <div className={style.fileItem_icon}>
              <DocumentNewIcon />
            </div>
            <div className={style.fileItem_content}>
              <div className={style.fileItem_name}>{file.name}</div>
              <div className={style.fileItem_size}>{(file.size / 1024).toFixed(2)} kb・загружено</div>
            </div>
            {isLoadingUpload ? (
              <Loading inBlock marginBottom={0} style={{ cursor: "pointer" }} />
            ) : (
              <EditIconNew width={24} height={24} onClick={handleReplaceFile} style={{ cursor: "pointer" }} />
            )}
            {isLoadingDelete ? (
              <Loading inBlock marginBottom={0} style={{ cursor: "pointer" }} />
            ) : (
              <DeleteNewIcon onClick={handleDeleteDocument} style={{ cursor: "pointer" }} />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default OrderDocumentUpload;
